import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalAprobacionPage } from './modal-aprobacion.page';

const routes: Routes = [
  {
    path: '',
    component: ModalAprobacionPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalAprobacionPageRoutingModule {}
